/* Preserve the draft and selected flavor after Shopify handles native forms. */
(() => {
  document.querySelectorAll('form[data-nu-return-fragment]').forEach(form => {
    const updateReturn = () => {
      const input = form.querySelector('input[name="return_to"]');
      if (!input) return;
      const url = new URL(location.href);
      ['contact_posted','customer_posted','form_type','utf8'].forEach(key => url.searchParams.delete(key));
      const fallback = new URL(input.value,location.origin);
      if (!url.searchParams.has('preview_theme_id') && fallback.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id',fallback.searchParams.get('preview_theme_id'));
      url.hash = form.dataset.nuReturnFragment;
      input.value = url.pathname + url.search + url.hash;
    };
    updateReturn();
    form.addEventListener('submit',updateReturn);
  });
})();
